/**
 * QC Analytics — Admin / Team Leader only
 *
 * Lives inside the Analytics module (/analytics/qc) as a tab alongside
 * Attendance / Downtime / Productivity / Performance Targets
 * (moved from a standalone top-level page per UAT feedback, Aug 2026).
 * The old /qc-analytics URL redirects here.
 */

import React, { useState } from 'react';
import { BarChart3, TrendingUp, AlertOctagon } from 'lucide-react';
import QCAnalytics from '../components/qc/QCAnalytics';
import QCAdvancedAnalytics from '../components/qc/QCAdvancedAnalytics';
import ExternalErrorsTab from '../components/qc/ExternalErrorsTab';

const TABS = [
  { id: 'basic', label: 'QC Analytics', icon: BarChart3 },
  { id: 'advanced', label: 'Advanced Analytics', icon: TrendingUp },
  { id: 'external', label: 'External Errors', icon: AlertOctagon },
];

const QCAnalyticsPage = () => {
  const [activeTab, setActiveTab] = useState('basic');

  return (
    <div data-testid="qc-analytics-page">
      {/* Sub-tab nav */}
      <div className="flex gap-2 mb-5">
        {TABS.map(t => {
          const Icon = t.icon;
          const active = activeTab === t.id;
          return (
            <button key={t.id} onClick={() => setActiveTab(t.id)}
              className={`an-tab an-btn flex items-center gap-2 px-3.5 py-2 rounded-lg text-[13px] font-medium ${
                active ? 'is-active' : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'}`}
              data-testid={`qc-analytics-tab-${t.id}`}>
              <Icon className="w-4 h-4" />{t.label}
            </button>
          );
        })}
      </div>

      {/* Content */}
      {activeTab === 'basic' && (
        <div className="an-rise bg-white rounded-2xl border border-slate-200/80 shadow-[0_1px_2px_rgba(15,23,42,.04),0_8px_24px_-14px_rgba(15,23,42,.14)] p-5">
          <QCAnalytics />
        </div>
      )}
      {activeTab === 'advanced' && <QCAdvancedAnalytics />}
      {activeTab === 'external' && (
        <div className="an-rise bg-white rounded-2xl border border-slate-200/80 shadow-[0_1px_2px_rgba(15,23,42,.04),0_8px_24px_-14px_rgba(15,23,42,.14)] p-5">
          <ExternalErrorsTab />
        </div>
      )}
    </div>
  );
};

export default QCAnalyticsPage;
